import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { globalServices, posServices } from "../../Services";
import { useContext } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { useState } from "react";
import { useEffect } from "react";
import { posVersionService } from "../../Services/posVersion.services";

const AddVersionToClient = ({ setShowAddToClient, showAddToClient }) => {
  const { t: translator } = useTranslation();
  const { register, errors } = useForm();
  const { userId } = useContext(AuthContext);
  const { locTenant } = useContext(GlobalContext);
  const [posVersions, setPosVersions] = useState();
  const [selectedVersion, setSelectedVersion] = useState();

  const [tenantList, setTenantList] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState("");
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const handleAddVersion = () => {
    console.log("selected vesrion and client", selectedVersion, selectedTenant);
    posVersionService
      .posAddToSelectedToTenantVersion(
        Number(selectedVersion),
        Number(selectedTenant)
      )
      .then((data) => {
        setShowAddToClient(false);
        setSelectedVersion(0);
        setSelectedTenant();
      });
  };

  useEffect(() => {
    posServices.getPosVersions().then((res) => {
      console.log("REZULTAT", res?.data);
      setPosVersions(res?.data);
    });
  }, []);

  useEffect(() => {
    const defaultSearchValue = "";

    globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        defaultSearchValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));

        result.unshift({
          id: "",
          label: translator("Select-Tenant"),
          value: "",
        });

        setTenantList(result);
      })
      .catch((err) => {
        console.error("Greška pri dohvatu tenanta:", err);
        return err;
      });
  }, [userId, locTenant]);

  return (
    <div>
      <Modal show={showAddToClient} centered onHide={setShowAddToClient}>
        <Modal.Header>
          <Modal.Title>
            {translator("ManagingVersion-AddVersion-Tenant")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          {localStorage.getItem("tenantId") === "null" && (
            <div className="form-group ">
              <label htmlFor="ddlStore">{translator("POS-View-Tenant")}</label>
              <select
                className="form-control"
                name="tenantId"
                value={selectedTenant}
                onChange={(e) => setSelectedTenant(e.target.value)}
              >
                {tenantList?.map((tenant) => (
                  <option key={tenant.id || tenant.value} value={tenant.value}>
                    {tenant.label}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="form-group">
            <label>{translator("Administration-PosVersion-Name")}</label>
            <div>
              <select
                ref={register({ required: true })}
                className="form-control"
                name="posVersionId"
                onChange={(e) => {
                  console.log(e.target.value);
                  setSelectedVersion(e.target.value);
                }}
              >
                <option value="0">{translator("Select-Version")}</option>
                {posVersions?.map((posVer) => (
                  <option key={posVer?.id} value={posVer.id}>
                    {translator(posVer?.name)}
                  </option>
                ))}
              </select>
            </div>
            {errors.noteId && errors.noteId.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {" "}
          <button
            onClick={() => setShowAddToClient(false)}
            className="btn btn-outline-secondary"
          >
            {translator("Btn-Cancel")}
          </button>
          <button
            appearance="primary"
            onClick={handleAddVersion}
            className="btn btn-primary"
          >
            {translator("Btn-Save")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddVersionToClient;
